import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { AdministrationModel } from '../../../../models/administration.model'
import { BankaccountResponseModel } from '../../../../models/bankaccount-response.model'
import { BankaccountsService } from '../../../../services/bankaccounts.service'
import { Subscription } from 'rxjs'
import { MatDialog, MatTableDataSource } from '@angular/material'
import { ActivatedRoute } from '@angular/router'
import { AdministrationBankaccountDialogComponent } from '../administration-bankaccount-dialog/administration-bankaccount-dialog.component'
import { FormGroup } from '@angular/forms'
import 'rxjs/add/operator/filter'
import { BankaccountModel } from '../../../../models/bankaccount.model'
import { BankService } from '../../../../services/bank/bank.service'
import { BankModel } from '../../../../models/bank.model'
import { ResourceLoadingService } from '../../../../services/resource-loading.service'

@Component({
  selector: 'app-administration-bankaccount',
  templateUrl: './administration-bankaccount.component.html',
  styleUrls: ['./administration-bankaccount.component.scss'],
})
export class AdministrationBankaccountComponent implements OnInit, OnDestroy {
  @Input() administration: AdministrationModel

  bankAccounts: BankaccountResponseModel
  onBankAccountsChange: Subscription
  banks: BankModel[]
  dataSource: any
  dialogRef: any
  displayedColumns = ['id', 'name', 'iban', 'type', 'balance', 'balance_date', 'state']
  selectedBankAccount: BankaccountModel

  constructor(
    private _bankAccountService: BankaccountsService,
    private _bankService: BankService,
    private _route: ActivatedRoute,
    private _loadingService: ResourceLoadingService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.administration = this._route.snapshot.data.administration
    this._loadingService.loading(true)
    this.onBankAccountsChange = this._bankAccountService.bankAccountsChanged
      .filter(response => !!response)
      .subscribe(data => {
        this._loadingService.loading(false)
        this.bankAccounts = data
        this.mapAccounts(this.bankAccounts)
      })

    this._bankAccountService.browse(this.administration.id).subscribe(data => {
      this.bankAccounts = data
      this.mapAccounts(this.bankAccounts)
    })

    this._bankService
      .browse()
      .filter(banks => !!banks)
      .subscribe(banks => {
        this.banks = banks
      })
  }

  openDialog() {
    this.dialogRef = this.dialog.open(AdministrationBankaccountDialogComponent, {
      panelClass: 'contact-form-dialog',
      data: {
        administration: this.administration,
      },
    })

    this.dialogRef
      .afterClosed()
      .filter(response => !!response)
      .subscribe((response: FormGroup) => {
        this._bankAccountService.create(response.getRawValue(), this.administration.id).subscribe()
      })
  }

  editAccount(bankAccount: BankaccountModel) {
    this.selectedBankAccount = bankAccount
    this.dialogRef = this.dialog.open(AdministrationBankaccountDialogComponent, {
      panelClass: 'contact-form-dialog',
      data: {
        administration: this.administration,
        bankAccount: bankAccount,
      },
    })

    this.dialogRef
      .afterClosed()
      .filter(response => !!response)
      .subscribe((response: FormGroup) => {
        const data = response.getRawValue()
        this.selectedBankAccount.name = data.name

        this._bankAccountService.update(this.selectedBankAccount, this.administration.id).subscribe(() => {
          this.selectedBankAccount = undefined
        })
      })
  }

  ngOnDestroy(): void {
    this.onBankAccountsChange.unsubscribe()
  }

  mapAccounts(bankAccounts: BankaccountResponseModel) {
    const adminArray = []

    for (const row of bankAccounts.items) {
      adminArray.push(row)
    }

    this.dataSource = new MatTableDataSource<BankaccountModel>(adminArray)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-bankaccount/administration-bankaccount.component.ts